import React from "react";
import { Link } from "react-router-dom";
import '../styles/StudentCard.css';
import gradIcon from '../images/grad-icon.svg';

export interface StudentCardProps {
    commonProgressId: number;
    id: string;
    title: string;
    firstName: string;
    lastName: string;
    studentStatus: string;
    studentStatusId: number;
    onClick: any;
    courseId: number;
    semesterId: number;
}

export default function StudentCard({ id, title, firstName, lastName, commonProgressId, studentStatus, studentStatusId, onClick, courseId, semesterId }: StudentCardProps) {

    let cardClassName = "StudentCard-card"

    if (studentStatusId === 5) {
        cardClassName = "StudentCard-card dropout"
    } else if (studentStatusId === 2) {
        cardClassName = "StudentCard-card grad completed"
    }

    return (
        <div className={cardClassName}>
            <Link to={`/curriculum/${courseId}/${semesterId}/common_goal/${id}/${commonProgressId}`} onClick={onClick} className="StudentCard-link">
                <div className="StudentCard-name-wrapper">
                    <p className="StudentCard-name">{title} {firstName} {lastName}</p>
                    {
                        studentStatusId === 2&&
                        <img src={gradIcon} alt="grad-icon" className="StudentCard-grad-icon" />
                    }
                    {studentStatusId === 5 &&
                        <span className="StudentCard-dropout-status">x พ้นสภาพฯ</span>
                    }
                </div>
                <p className="StudentCard-studentID">{id}</p>
                {studentStatusId === 2 &&
                    <div className="StudentCard-deadline">
                        <p className="StudentCard-status">Graduated</p>
                    </div>
                }
            </Link>
        </div>

    )
}